<div class="p-4">
  <form [formGroup]="form" class="flex flex-col gap-4" *ngIf="formInitialized">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Première colonne -->
      <div class="flex flex-col gap-4">
        <p-card styleClass="mb-4">
          <ng-template pTemplate="title">
            <div class="card-title flex items-center">
              <i class="pi pi-clock text-xl mr-2 text-primary"></i>
              <h2 class="text-lg font-medium m-0">Programmation</h2>
            </div>
          </ng-template>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium">Date de début</label>
            <p-datePicker
              formControlName="startDate"
              [showTime]="true"
              [minDate]="minDate"
              [showIcon]="true"
              styleClass="w-full"
              dateFormat="dd/mm/yy"
              hourFormat="24"
              placeholder="Sélectionner la date de début"
            ></p-datePicker>
          </div>

          <!-- Switch pour le créneau horaire -->
          <div class="flex items-center mb-4">
            <p-toggleSwitch
              formControlName="isTimeSlot"
              (onChange)="toggleTimeSlot()"
            ></p-toggleSwitch>
            <span class="ml-2 text-sm">Créneau horaire</span>
          </div>

          <!-- Options de créneau horaire - visible uniquement si isTimeSlot est true -->
          <div *ngIf="form.get('isTimeSlot')?.value" class="mb-4">
            <div class="flex flex-wrap gap-2">
              <p-button
                label="Matin (8h-12h)"
                styleClass="p-button-sm"
                [outlined]="selectedTimeSlot !== 'morning'"
                [raised]="selectedTimeSlot === 'morning'"
                (onClick)="selectTimeSlot('morning')"
              ></p-button>
              <p-button
                label="Après-midi (13h-18h)"
                styleClass="p-button-sm"
                [outlined]="selectedTimeSlot !== 'afternoon'"
                [raised]="selectedTimeSlot === 'afternoon'"
                (onClick)="selectTimeSlot('afternoon')"
              ></p-button>
              <p-button
                label="Personnalisé"
                styleClass="p-button-sm"
                [outlined]="selectedTimeSlot !== 'custom'"
                [raised]="selectedTimeSlot === 'custom'"
                (onClick)="selectTimeSlot('custom')"
              ></p-button>
            </div>

            <!-- Afficher un avertissement si le créneau ne correspond pas à la date -->
            <div
              *ngIf="timeSlotMismatch"
              class="p-2 mt-2 bg-yellow-100 text-yellow-800 rounded text-xs flex items-center"
            >
              <i class="pi pi-exclamation-triangle mr-2"></i>
              <span>
                La date sélectionnée n'est pas dans le créneau horaire choisi
              </span>
              <button
                class="ml-2 p-1 bg-yellow-200 rounded"
                (click)="updateTimeSlotToMatchDate()"
              >
                Ajuster
              </button>
            </div>

            <div class="grid grid-cols-2 gap-4 mt-2">
              <div>
                <label class="block mb-2 text-sm font-medium">
                  Heure de début
                </label>
                <p-datePicker
                  formControlName="startTimeSlot"
                  [timeOnly]="true"
                  [showSeconds]="false"
                  hourFormat="24"
                  styleClass="w-full"
                  placeholder="Heure de début"
                ></p-datePicker>
              </div>
              <div>
                <label class="block mb-2 text-sm font-medium">
                  Heure de fin
                </label>
                <p-datePicker
                  formControlName="endTimeSlot"
                  [timeOnly]="true"
                  [showSeconds]="false"
                  hourFormat="24"
                  styleClass="w-full"
                  placeholder="Heure de fin"
                ></p-datePicker>
              </div>
            </div>
          </div>
          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium">Durée</label>
            <p-datePicker
              formControlName="duration"
              [timeOnly]="true"
              [showSeconds]="false"
              hourFormat="24"
              styleClass="w-full"
              placeholder="Durée de l'intervention"
            ></p-datePicker>
          </div>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium">Assistant(e)</label>
            <p-select
              formControlName="userAssistantId"
              [options]="users"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              placeholder="Sélectionner un(e) assistant(e)"
              styleClass="w-full"
            ></p-select>
          </div>
        </p-card>
      </div>

      <!-- Deuxième colonne -->
      <div class="flex flex-col gap-4">
        <p-card styleClass="mb-4">
          <ng-template pTemplate="title">
            <div class="card-title flex items-center">
              <i class="pi pi-users text-xl mr-2 text-primary"></i>
              <h2 class="text-lg font-medium m-0">
                Technicien(nes) assigné(es)
              </h2>
            </div>
          </ng-template>

          <div class="mb-4">
            <label class="block mb-2 text-sm font-medium">Techniciens</label>
            <p-multiSelect
              formControlName="techniciansIds"
              [options]="users"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              selectedItemsLabel="{0} techniciens sélectionnés"
              placeholder="Sélectionner des techniciens"
              styleClass="w-full"
              (onChange)="checkTechniciansErpSource($event.value)"
            ></p-multiSelect>
            <p
              *ngIf="techniciansIncompatibleErp"
              class="text-red-500 text-sm mt-1"
            >
              Impossible de sélectionner des techniciens de sociétés différentes
            </p>
          </div>

          <div class="mb-4">
            <div class="flex items-center">
              <p-toggleSwitch
                formControlName="isConfirmed"
                styleClass="mr-2"
              ></p-toggleSwitch>
              <label class="text-sm font-medium">
                Créneau confirmé avec le client
              </label>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </form>
</div>
